import { ContentState } from './types'
import Book from '@/store/models/book'
import Course from '@/store/models/course'

const state: ContentState = {
  gradesTree: [],
  contentCache: {},
  bookTree: { book: new Book(), categories: {}, course: new Course(), rootIds: [] },
  filters: {},
  searchTags: []
}

export default state
